export const FirstCharFilterModule = angular
    .module('app.filters.firstCharFilter', [])
    .filter('firstChar', () => (s) => {
        return s ? s[0] : '';
    }).name;


// WEBPACK FOOTER //
// ./src/app/filters/firstChar.filter.js